<template>
  <div>
    <div style="padding-top: 20px; padding-bottom: 20px">
      图片文件
    </div>
    <!-- 新增一个input用于平板端拍照/多图上传，隐藏显示，兼容原有上传 -->
    <!-- <button v-if="show" @click="openCamera" style="margin-bottom: 10px;">拍照/选择图片</button>
    <input
      ref="fileInput"
      type="file"
      accept="image/*"
      capture="environment"
      multiple
      style="display: none"
      @change="handleFilesChange"
    /> -->
    <!-- <div v-if="previewUrls.length" style="margin-bottom:10px;">
      <p>图片预览：</p>
      <div style="display: flex; flex-wrap: wrap;">
        <div v-for="(url, idx) in previewUrls" :key="idx" style="margin: 5px; position: relative;">
          <img :src="url" style="max-width: 100px; max-height: 100px; border: 1px solid #eee;" />
          <span
            @click="removePreviewImage(idx)"
            style="position: absolute; top: 2px; right: 2px; cursor: pointer; background: rgba(255,255,255,0.8); border-radius: 50%; padding: 2px;"
            title="移除"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </span>
        </div>
      </div>
      <button @click="uploadAllImages" style="margin-top: 10px;">上传全部图片</button>
    </div> -->
    <!-- 原有的多图上传控件 -->
    <j-image-upload
      class="avatar-uploader"
      :disabled="!show"
      :is-multiple="true"
      text="上传"
      @change="uploadChange"
      v-model="imageList"
      :bizPath="`${projectId}/${patientId}/formImage/${formId}`"
      @remove="removeHandle"
    ></j-image-upload>
  </div>
</template>

<script>
import JImageUpload from '@/components/jeecg/JImageUpload'
import { postAction, getAction, deleteAction } from '@/api/manage'

export default {
  name: 'ImageFile',
  components: { JImageUpload },
  props: {
    show: {
      default: true
    },
    projectId: {
      default: ''
    },
    patientId: {
      default: ''
    },
    formId: {
      default: ''
    }
  },
  data() {
    return {
      imageList: [],
      files: [],
      previewUrls: []
    }
  },
  computed: {
    uploadAction() {
      return `${window._CONFIG['domianURL']}/sys/common/upload`
    }
  },
  watch: {
    formId() {
      this.loadData()
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      getAction('/project/projectFile/listAll', { serveId: this.formId, projectId: this.projectId, type: '6' }).then(res => {
        if (res.success) {
          const fileList = []
          res.result.forEach(item => {
            if (item.path) {
              fileList.push(item.path)
            }
          })
          this.imageList = fileList
        }
      })
    },
    removeHandle(file) {
      deleteAction('/project/projectFile/deleteByPath', { path: file.response.message }).then(res => {
        if (res.success) {
          this.loadData()
        }
      })
    },
    uploadChange(pathListStr) {
      if (pathListStr) {
        const pathList = pathListStr.split(',')
        const path = pathList[pathList.length - 1]
        const paths = path.split('/')
        const fileNameInfo = paths[paths.length - 1].split('.')
        const formData = {
          serveId: this.formId,
          projectId: this.projectId,
          name: fileNameInfo[0],
          suffix: fileNameInfo[1],
          type: '6',
          path: path
        }
        postAction('/project/projectFile/add', formData).then(res => {
          this.loadData()
        }).finally(() => {})
      }
    },
    openCamera() {
      this.$refs.fileInput.value = null // 允许重复选择相同照片
      this.$refs.fileInput.click()
    },
    handleFilesChange(event) {
      const selectedFiles = Array.from(event.target.files)
      selectedFiles.forEach(file => {
        const url = URL.createObjectURL(file)
        this.previewUrls.push(url)
        this.files.push(file)
      })
    },
    removePreviewImage(idx) {
      URL.revokeObjectURL(this.previewUrls[idx])
      this.previewUrls.splice(idx, 1)
      this.files.splice(idx, 1)
    },
    uploadAllImages() {
      if (!this.files.length) return alert('请选择图片！')
      // 批量上传每一张图片
      const formDataList = []
      this.files.forEach(file => {
        const formData = new FormData()
        formData.append('file', file)
        formDataList.push(formData)
      })
      // 假设上传接口为 /sys/common/upload，实际需结合业务API
      const uploadPromises = formDataList.map(formData => {
        return postAction('/sys/common/upload', formData, {
          // 如需额外参数可在这里补充
        })
      })
      Promise.all(uploadPromises)
        .then(resArr => {
          // 逐个添加到项目文件表
          const addOps = resArr.map(res => {
            if (res.success && res.message) {
              const path = res.message
              const paths = path.split('/')
              const fileNameInfo = paths[paths.length - 1].split('.')
              // 构造登记数据
              const formData = {
                serveId: this.formId,
                projectId: this.projectId,
                name: fileNameInfo[0],
                suffix: fileNameInfo[1],
                type: '6',
                path: path
              }
              return postAction('/project/projectFile/add', formData)
            } else {
              return Promise.resolve()
            }
          })
          return Promise.all(addOps)
        })
        .then(() => {
          alert('上传成功')
          this.files = []
          this.previewUrls.forEach(url => URL.revokeObjectURL(url))
          this.previewUrls = []
          this.loadData()
        })
        .catch(() => {
          alert('上传失败')
        })
    }
  }
}
</script>